import { canRegisterOfflineShell } from "./offline-shell-policy.ts";

/** Registration is best-effort; true means registered, not installed/offline-ready. */
export async function registerOfflineShell(): Promise<boolean> {
  const environment = (import.meta as ImportMeta & { env?: { DEV?: boolean } }).env;
  if (
    environment?.DEV
    || typeof window === "undefined"
    || typeof navigator === "undefined"
    || !("serviceWorker" in navigator)
    || !canRegisterOfflineShell(new URL(window.location.href))
  ) return false;
  try {
    await navigator.serviceWorker.register("/sw.js", { scope: "/", updateViaCache: "none" });
    return true;
  } catch {
    // Private-mode, unsupported browser or install/network failure must never
    // prevent the normal online app from starting.
    return false;
  }
}
